import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// eslint-disable-next-line no-unused-vars
import AdditionalErrorData from "./AdditionalErrorData";
var AdditionalErrorDataMessageProvider = /*#__PURE__*/function () {
  function AdditionalErrorDataMessageProvider() {
    _classCallCheck(this, AdditionalErrorDataMessageProvider);
    this.providers = {};
  }
  _createClass(AdditionalErrorDataMessageProvider, [{
    key: "addProvider",
    value: function addProvider(provider) {
      this.providers[provider.getIdentifier()] = provider;
    }

    /**
     * @param {Error} error
     * @param {AdditionalErrorData} additionalData
     *
     * @returns {string[]}
     */
  }, {
    key: "getMessage",
    value: function getMessage(error, additionalData) {
      return Object.values(this.providers).reduce(function (accumulator, provider) {
        var additionalDataMessage = provider.getMessage(error, additionalData);
        if (additionalDataMessage === null) {
          return accumulator;
        }
        return [].concat(_toConsumableArray(accumulator), [additionalDataMessage]);
      }, []);
    }
  }]);
  return AdditionalErrorDataMessageProvider;
}();
export default new AdditionalErrorDataMessageProvider();